import sessionMixin from "@/components/shared/mixins/sessionMixin";

export default {
  mixins: [sessionMixin],
  name: "SignatureEditBtn",
  props: {
    isOtherInfo: {
      type: Boolean,
      default: false
    },
    guest: {
      type: Object
    }
  },
  methods: {
    editGuest() {
      this.$emit("click", this.guest, this.isOtherInfo);
    }
  }
};
